import { createFileRoute } from '@tanstack/react-router';

import { PageLayout } from 'components/PageLayout';

export const Route = createFileRoute('/_auth/_layout')({
  component: PageLayout,
});
